import { render, staticRenderFns } from "./AmpereForceViz.vue?vue&type=template&id=280cc713&scoped=true"
import script from "./AmpereForceViz.vue?vue&type=script&lang=js"
export * from "./AmpereForceViz.vue?vue&type=script&lang=js"
import style0 from "./AmpereForceViz.vue?vue&type=style&index=0&id=280cc713&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cc713",
  null
  
)

export default component.exports